// dependency
import "../../theme/src/common/transitions.scss"
import "../../theme/src/components/loading.scss"

// current
import "../../theme/src/components/spinner.scss"
